const sortDirs = {
    ASC: 1,
    DESC: 2,
    NONE: 3,
};

export { sortDirs };
